/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line








  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

window.addEventListener('load', function() {
const waitForReviewCount = setInterval(() => {
  const reviewCountEl = document.querySelector(".oke-w-ratingAverageModule-count");
  const reviewWidgetTitle = document.querySelector("#review-widget-title");
  const reviewWidgetcount = document.querySelector("#rating_star_block .rating_count");

  // Check if both elements are available and have the expected text
  if (reviewCountEl && reviewCountEl.textContent.includes("Based on")) {
    const text = reviewCountEl.textContent.trim();
    const match = text.match(/\d+/);

    if (match) {
      const count = match[0];
      reviewCountEl.textContent = reviewWidgetcount.innerHTML;

      const reviewSummary = document.createElement("div");
      reviewSummary.className = "section-title";
      reviewSummary.innerHTML = reviewWidgetTitle.innerHTML;

      // Insert after reviewCountEl
      reviewCountEl.parentNode.insertBefore(reviewSummary, reviewCountEl.nextSibling);
    }

    // Stop polling
    clearInterval(waitForReviewCount);
  }
}, 300);


});

// sticky-add-to-cart
// document.addEventListener("DOMContentLoaded", function () {
//   var stickyBar = document.getElementById("sticky-add-to-cart");
//   var productSection = document.querySelector('#product-wrapper .product__submit__buttons');
//   var footer = document.getElementById("SiteFooter");

//   function isElementInView(el) {
//     if (!el) return false;
//     var rect = el.getBoundingClientRect();
//     return rect.top < window.innerHeight && rect.bottom > 0;
//   }

//   function checkProductVisibility() {
//     var productInView = isElementInView(productSection);
//     var footerInView = isElementInView(footer);

//     if (productInView || footerInView) {
//       stickyBar.classList.add("sticky-cart-hidden");
//     } else {
//       stickyBar.classList.remove("sticky-cart-hidden");
//     }
//   }

//   window.addEventListener("scroll", checkProductVisibility);
//   window.addEventListener("load", checkProductVisibility);
// });

document.addEventListener("DOMContentLoaded", function () {
  var stickyBar = document.getElementById("sticky-add-to-cart");
  var productSection = document.querySelector('#product-wrapper .product__submit__buttons');
  var footer = document.getElementById("SiteFooter");

  function checkProductVisibility() {
    if (!productSection || !stickyBar) return;

    var productBottom = productSection.getBoundingClientRect().bottom;
    var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;

    if (productBottom > 0 || footerTop < window.innerHeight) {
      stickyBar.classList.add("sticky-cart-hidden");
    } else {
      stickyBar.classList.remove("sticky-cart-hidden");
    }
  }

  window.addEventListener("scroll", checkProductVisibility);
  window.addEventListener("load", checkProductVisibility);
  window.addEventListener("resize", checkProductVisibility);
});






